<template>
  <div>
    <div v-if="show" class="x-nav">
      <div class="x-nav-fixed a-ipx-top-border" :style="'background-color: ' + bgColor">
        <div v-if="showNavBack" class="x-nav-back" @click="onClickBack">
          <div
            class="x-nav-back-arrow"
            :style="'border-left: 2px solid '+fontColor+'; border-bottom: 2px solid '+fontColor+';'"
          ></div>
        </div>
        <div
          class="x-nav-title"
          :class="{'a-text-medium': titleMedium}"
          :style="'color: ' + fontColor + ';background-color: ' + bgColor || '#ffffff'"
          v-show="!isEnterpriseUser&&showTitleText"
        >{{ $nav.title }}</div>
        <div
          v-show="isEnterpriseUser" class="enterpriseBlock" @click="switchTab">
          <div class="slider" ref="slider" :style="sliderStyle">
          </div>
          <div class="tabButton" :style="enterpriseStyle">
            因公
          </div>
          <div class="tabButton" :style="personalStyle">
            因私
          </div>
        </div>
        <div
          v-if="navRightBtn"
          class="x-nav-btn"
          :style="'color: ' + fontColor"
          @click="navRightBtn.fn"
        >{{navRightBtn.name}}</div>
      </div>
      <div class="placeholder a-ipx-border-border" :style="'background-color: ' + bgColor"></div>
    </div>
  </div>
</template>

<script>

/**
 * url里加参数firstNoBack=1，则入口页的nav不展示回退按钮
 */

import enterpriseList from '@/DATA/enterprise-list.js';
import env            from '@/utils/env.js';
import localStorage   from '@/utils/localStorage.js';

export default {
  name: "c-nav",

  props : [
    'bgColor',       'fontColor', 'navRightBtn', 'isEnterpriseUser',
    'useEnterprise', 'titleMedium'
  ],

  computed: {
    show() {
      let result;

      result = false;

      if ( this.$nav.show ) {
        result = true;
      } else if ( enterpriseList.indexOf( env.partner ) >= 0 ) {
        if ( this.$route.path === '/ticketAgent/home' ) {
          result = true;
        }
      }

      return result;
    },

    showTitleText() {
      const ptid = localStorage.get( 'ptid' );

      return ptid !== 'jinjiang';
    },

    showNavBack() {
      if (this.$nav.firstPageShowBack) {
        return this.$nav.showBack;
      } else {
        let historyLen = window.gtHistoryPageLen;
        return !historyLen || historyLen === 1 ? false : this.$nav.showBack;
      }
    },

    sliderStyle() {
      let result;

      if ( parseInt( this.useEnterprise ) === 1 ) {
        result = {
          transform : 'translateX( 0 )'
        };
      } else {
        result = {
          transform : 'translateX( 51px )'
        };
      }

      return result;
    },

    enterpriseStyle() {
      return parseInt( this.useEnterprise ) === 1 ? {
        color : '#333333'
      } : {
        color : '#ffffff'
      };
    },

    personalStyle() {
      return parseInt( this.useEnterprise ) === 1 ? {
        color : '#ffffff'
      } : {
        color : '#333333'
      };
    }
  },
  methods: {
    onClickBack() {
      if (this.$route.query.paid) {
        this.$router.go(-2);
      } else {
        this.$router.back();
      }
    },

    switchTab() {
      this.$emit( 'switchTab' );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.x-nav-fixed {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  background-color: #fff;
  height: $x-nav-height;
  max-width: 750px;
  margin: 0 auto;
}
.x-nav-back {
  position: absolute;
  padding: 15px 20px;
}
.x-nav-back-arrow {
  width: 12px;
  height: 12px;
  border-left: 2px solid #000;
  border-bottom: 2px solid #000;
  transform: rotate(45deg);
}
.x-nav-title {
  padding: 10px 30px;
  font-size: 0.9rem;
  /* height: 20px; */
  line-height: 2.2rem;
  color: #000;
  background-color: #fff;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  padding: 0 50px;
}
.x-nav-btn {
  position: absolute;
  font-size: 17px;
  right: 0;
  top: 0;
  padding: 10px;
}
.placeholder {
  width: 100%;
  height: $x-nav-height;
  background-color: #fff;
}

  .enterpriseBlock {
    font-size     : 0;
    position      : relative;
    width         : 102px;
    height        : 24px;
    left          : 50%;
    top           : 50%;
    transform     : translate( -50%, -50% );
    border-radius : 12px;
    border        : 1px solid #ffffff;
    box-sizing    : border-box;
  }

  .tabButton {
    display     : inline-block;
    font-size   : 13px;
    width       : 50%;
    height      : 24px;
    line-height : 24px;
    text-align  : center;
    transition  : all 0.3s;
  }

  .slider {
    width            : 50%;
    height           : 26px;
    border-radius    : 13px;
    background-color : #ffffff;
    position         : absolute;
    top              : -2px;
    left             : 0;
    transition       : all 0.3s;
    z-index          : -1;
  }
</style>



// WEBPACK FOOTER //
// src/components/c-nav.vue